export default __webpack_public_path__ + "static/media/dutch-min.870c514e.png";